export const getUserInitials = (firstName: string, lastName: string) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : ''
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : ''
  return firstInitial + lastInitial
}

export const getUserDisplayName = (firstName: string, lastName: string) => {
  if (!firstName && !lastName) return ''
  return `${firstName || ''} ${lastName || ''}`.trim()
}
